import { ROUTES_CONFIG } from '@/config/routes.config'
import { Route } from 'react-router-dom'
import LoginPage from './login/page'
import RegisterPage from './register/page'

export const authRoutes = (
  <Route path={ROUTES_CONFIG.AUTH.$path()}>
    <Route path={ROUTES_CONFIG.AUTH.LOGIN.$path()} element={<LoginPage />} />
    <Route path={ROUTES_CONFIG.AUTH.REGISTER.$path()} element={<RegisterPage />} />
    <Route path={ROUTES_CONFIG.AUTH.FORGOT_PASSWORD.$path()} element={<div>Forgot Password</div>} />
    <Route path={ROUTES_CONFIG.AUTH.RESET_PASSWORD.$path()} element={<div>Reset Password</div>} />
    <Route path={ROUTES_CONFIG.AUTH.LOGOUT.$path()} element={<div>Logout</div>} />
  </Route>
)